<template>
  <div
    class="modal fade"
    id="appNearExpireAndExpireModal"
    ref="appNearExpireAndExpireModal"
    style="z-index: 1999"
    tabindex="2"
    role="dialog"
    aria-labelledby="appNearExpireAndExpireModalLabel"
    data-backdrop="static"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div
        v-if="$parent.showAppNearExpireType == 'Near'"
        class="modal-content"
      >
        <div class="modal-header bg-warning">
          <h5 class="modal-title">
            <span>
              <i class="fa-solid fa-envelope-open-dollar mr-2" />{{ $t("Subscription App Near Expired") }}
            </span>
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            @click="closeModal()"
          >
            ×
          </button>
        </div>
        <div class="modal-body">
          <div class=" text-center">
            <div>
              <img
                :src="$storeIndex.getImageSrc('banner-subscription-near-expired')"
                class="mb-3 img-fluid"
                style="width:110px;"
              >
            </div>
            <div class="h4">
              {{ textNearExpire }} {{ textExpiresIn }}!
            </div>
            <div class="px-5">
              {{ textNearExpireDetail }}
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-center">
          <button
            type="button"
            class="btn btn-outline-warning mr-3"
            data-dismiss="modal"
            @click="okNearExpire()"
          >
            <i class="fa-regular fa-thumbs-up fa-1x mr-1" /> {{ $t('OK') }}
          </button>
        </div>
      </div>
      <div
        v-else-if="$parent.showAppNearExpireType == 'Expire'"
        class="modal-content"
      >
        <div class="modal-header bg-danger">
          <h5 class="modal-title">
            <span>
              <i class="fa-solid fa-envelope-open-dollar mr-2" />{{ $t("Subscription Expired") }}
            </span>
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            @click="closeModal()"
          >
            ×
          </button>
        </div>
        <div class="modal-body">
          <div class=" text-center">
            <div>
              <img
                :src="$storeIndex.getImageSrc('banner-subscription-near-expired')"
                class="mb-3 img-fluid"
                style="width:110px;"
              >
            </div>
            <div class="h4">
              {{ textExpire }}
            </div>
            <div class="px-5">
              {{ textExpireDetail }}
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-center">
          <button
            type="button"
            class="btn btn-outline-danger mr-3"
            data-dismiss="modal"
            @click="okExpire"
          >
            <i class="fa-regular fa-thumbs-up fa-1x mr-1" /> {{ $t('OK') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
export default {
  name: "ModalAppNearExpireAndExpire",
  data() {
    return {
      textNearExpire: this.$t('App Subscription Near Expires in'),
      textNearExpireDetail: this.$t("Your unmask data has near expires. If you want to continue using it or feel this is a mistake, contact your admin"),
      textExpire: this.$t('App Subscription Expired!'),
      textExpireDetail: this.$t('Your unmask data has expired. If you want to continue using it or feel this is a mistake, contact your admin.'),
      tenant: JSON.parse(Cookies.get('tenant'))
    };
  },
  mounted() {
    this.showModal();

    $(this.$refs.appNearExpireAndExpireModal).on("hidden.bs.modal", () => {
      this.$parent.showAppNearExpire = false;
    });
  },
  computed: {
    textExpiresIn() {
      let text = '';
      if(this.$parent.appExpiredIn >= 24){
        let daysLeft = this.$parent.appExpiredIn/24;
        text = Math.round(daysLeft) +' '+ this.$t('Days');
      }
      if(this.$parent.appExpiredIn > 0 && this.$parent.appExpiredIn < 24)
      {
        let timesLeft = this.$parent.appExpiredIn;
        text = parseInt(timesLeft).toFixed(0) +' '+ this.$t('hours');
      }
      return text;
    }
  },
  methods: {
    showModal() {
      setTimeout(() => {
        $('#appNearExpireAndExpireModal').modal('show');
      }, 500);
    },
    okExpire() {
      this.closeModal();
    },
    okNearExpire() {
      Cookies.set('okAppNearExpire_'+this.tenant.id+ '_planUnmaskData', 'true', { domain: '.' + process.env.CENTRAL_API_ROOT, expires: 1  });
      this.closeModal();
    },
    closeModal(){
      this.$store.dispatch("user/showPlanNoti", false);
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/ModalAppNearExpireAndExpire.vue